var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvenArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4902 20.7599C15.3002 20.7599 15.1102 20.6899 14.9602 20.5399C14.6702 20.2499 14.6702 19.7699 14.9602 19.4799L19.9702 14.4699C20.2602 14.1799 20.7402 14.1799 21.0302 14.4699C21.3202 14.7599 21.3202 15.2399 21.0302 15.5299L16.0202 20.5399C15.8702 20.6799 15.6802 20.7599 15.4902 20.7599Z",
    fill: "#101323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.74H3.5C3.09 15.74 2.75 15.4 2.75 14.99C2.75 14.58 3.09 14.24 3.5 14.24H20.5C20.91 14.24 21.25 14.58 21.25 14.99C21.25 15.4 20.91 15.74 20.5 15.74Z",
    fill: "#101323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49994 9.75994C3.30994 9.75994 3.11994 9.68994 2.96994 9.53994C2.67994 9.24994 2.67994 8.76994 2.96994 8.47994L7.97994 3.46994C8.26994 3.17994 8.74994 3.17994 9.03994 3.46994C9.32994 3.75994 9.32994 4.23994 9.03994 4.52994L4.02994 9.53994C3.88994 9.67994 3.68994 9.75994 3.49994 9.75994Z",
    fill: "#101323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.76001H3.5C3.09 9.76001 2.75 9.42001 2.75 9.01001C2.75 8.60001 3.09 8.26001 3.5 8.26001H20.5C20.91 8.26001 21.25 8.60001 21.25 9.01001C21.25 9.42001 20.91 9.76001 20.5 9.76001Z",
    fill: "#101323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvenArrowIcon);
export default __webpack_public_path__ + "static/media/evenArrowIcon.6c7d6a5858cd0f6e329e6caf10eb4ea7.svg";
export { ForwardRef as ReactComponent };